import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';

import { Card, TextHeader } from '@/UI';
import { useIframeRouter } from '@/hooks/useIframeRouter';

import { LocalIconInfo } from '../LocalIconInfo';

import * as St from './CardLocalItem.styles';
import { CardLocalItemProps } from './types';

export const CardLocalItem: FC<CardLocalItemProps> = ({
  location,
  setSelectedLocation,
  isSelected,
  queryParams,
  onClickOverride,
}) => {
  const { id, locationName, address, image } = location;
  const [isDetailShown, setIsDetailShown] = useState(false);
  const { t } = useTranslation();
  const router = useRouter();
  const { countryCode } = router.query as { countryCode: string };
  const { routerPush } = useIframeRouter();

  useEffect(() => {
    if (!isSelected) {
      setIsDetailShown(false);
    }
  }, [isSelected]);

  return (
    <St.Wrapper
      data-testid="cardLocalItem"
      onClick={() => {
        if (onClickOverride) {
          onClickOverride();
          return;
        }
        routerPush(`/${countryCode}/sucursal/${id}/${queryParams}`);
      }}
    >
      <Card className="card">
        <St.LocalImgContainer data-testid="banner">
          {image ? (
            <St.LocalImg src={image} layout="fill" alt={`${t('IMG_ALT_LOCATION_IMAGE')}`} />
          ) : (
            <St.BannerGradient />
          )}
        </St.LocalImgContainer>
        <St.Content>
          <TextHeader heading="h2" className="title" size="subHeadline">
            {locationName}
          </TextHeader>
          {address && (
            <LocalIconInfo
              testId="address"
              info={address.replace(/^(,\s){1,}/, '')}
              className={`${!isDetailShown ? 'addressText' : ''}`}
            />
          )}
        </St.Content>
      </Card>
    </St.Wrapper>
  );
};
